var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.business_around),function(item){return _c('Business',{key:item.id,attrs:{"business":item}})}),_c('infinite-loading',{on:{"infinite":_vm.infiniteHandler}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }